export enum RouteSchuleMenuGroup {
	ALLGEMEIN = "Allgemein",
	KATALOGE = "Kataloge",
	DATENAUSTAUSCH = "Datenaustausch",
	REPORTING = "Reporting"
}
